import PropTypes from 'prop-types'

const styles = {
    wrapper: {
        textAlign: 'center',
        alignItems: 'flex-start',
        display: 'flex',
        // width: '100%',
        overflowX: 'scroll',
        WebkitOverflowScrolling: 'touch',
        borderBottom: '2px solid #EBF0F9',
    },
    item: {
        fontSize: 14,
        fontWeight: 400,
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        padding: '5px 15px',
        display: 'inline-block',
        color: '#A8B0C0',
        // width: 'max-content',
        whiteSpace: 'nowrap',
        // overflowWrap: 'none',
    },
    itemActive: {
        fontWeight: 700,
        borderBottom: '2px solid #2772FF',
        color: '#2772FF',
    },
}

const Tabs = ({ tabs, activeTab, setActiveTab, justifyContent }) => {
    return (
        <div style={{
            ...styles.wrapper,
            justifyContent: justifyContent || 'flex-start',
        }}>
            {tabs.map(i => {
                let el = null
                return (
                    <div
                        ref={e => (el = e)}
                        key={i.key}
                        style={{
                            ...styles.item,
                            ...(activeTab === i.key ? styles.itemActive : {}),
                            // width: `${1 / tabs.length * 100}%`,
                        }}
                        onTouchStart={() => {
                            el.style.backgroundColor = '#F4F4F4'
                        }}
                        onTouchEnd={() => {
                            el.style.backgroundColor = '#fff'
                        }}
                        onClick={() => setActiveTab(i.key)}
                        children={i.label}
                    />
                )
            })}
        </div>
    )
}

Tabs.propTypes = {
    tabs: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string,
        label: PropTypes.string,
    })),
    activeTab: PropTypes.string,
    setActiveTab: PropTypes.func,
    justifyContent: PropTypes.string,
}

Tabs.defaultProps = {
    tabs: [],
    activeTab: null,
    setActiveTab: () => null,
    justifyContent: 'flex-start',
}

export default Tabs
